import { FB_EVENTS, sendCustomFBEvent } from 'commons/fbEvents';
import { useEffect, useMemo } from 'react';

const DEFAULT_BASIC_DETAILS = {};
const DEFAULT_VARIANT_SKU = '';

const useJbEventFBSelectVariation = (
  basicDetails = DEFAULT_BASIC_DETAILS,
  selectedOptionsVariantSku = DEFAULT_VARIANT_SKU
) => {
  const {
    baseSku = '',
    name = '',
    type: { name: productName = '' } = {},
  } = useMemo(() => basicDetails, [basicDetails]);

  const sku = baseSku + selectedOptionsVariantSku;

  useEffect(() => {
    if (productName && sku && name) {
      window.jbEventFBSelectVariation = () => {
        sendCustomFBEvent(FB_EVENTS.SELECT_VARIATION, {
          content_category: productName,
          content_ids: [sku],
          content_name: name,
          content_type: 'product',
        });
      };
    } else {
      window.jbEventFBSelectVariation = undefined;
    }
  }, [name, productName, sku]);
};

export default useJbEventFBSelectVariation;
